import { clsx } from "clsx";
import { Check } from "lucide-react";

/** A done toggle: 18 px control skin (a 44 px target on touch), accent when checked, always with an accessible name. */
export function Checkbox({
  checked,
  onChange,
  label,
  disabled,
  className,
}: {
  checked: boolean;
  onChange(next: boolean): void;
  label: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={clsx(
        "kss-control relative grid h-[18px] w-[18px] shrink-0 place-items-center rounded-[5px] transition disabled:cursor-not-allowed disabled:opacity-50",
        // touch screens: a 44 px target around the same 18 px box
        "touch:after:absolute touch:after:-inset-[13px]",
        checked
          ? "border-accent bg-accent text-white"
          : "hover:border-neutral-700 dark:hover:border-neutral-400",
        className,
      )}
    >
      {checked && <Check size={13} strokeWidth={3} aria-hidden />}
    </button>
  );
}
